var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMouseSpark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.274,
    height: 22.2,
    viewBox: "0 0 22.274 22.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4288",
    "data-name": "Group 4288",
    transform: "translate(-6 -4.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7482",
    "data-name": "Path 7482",
    className: "cls-1",
    d: "M20.55,7.6a.709.709,0,0,0,.75-.75V5.05a.75.75,0,1,0-1.5,0V6.925A.74.74,0,0,0,20.55,7.6Z",
    transform: "translate(-3.449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7483",
    "data-name": "Path 7483",
    className: "cls-1",
    d: "M21.3,32.025V30.15a.75.75,0,1,0-1.5,0v1.875a.75.75,0,1,0,1.5,0Z",
    transform: "translate(-3.449 -6.275)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7484",
    "data-name": "Path 7484",
    className: "cls-1",
    d: "M31.95,19.6h1.875a.75.75,0,0,0,0-1.5H31.95a.75.75,0,0,0,0,1.5Z",
    transform: "translate(-6.301 -3.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7485",
    "data-name": "Path 7485",
    className: "cls-1",
    d: "M6.75,18.1a.75.75,0,0,0,0,1.5H8.625a.75.75,0,0,0,0-1.5Z",
    transform: "translate(0 -3.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7486",
    "data-name": "Path 7486",
    className: "cls-1",
    d: "M29.375,8.525l-1.35,1.35a.725.725,0,0,0,0,1.05.725.725,0,0,0,1.05,0l1.35-1.35a.742.742,0,0,0-1.05-1.05Z",
    transform: "translate(-5.449 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7487",
    "data-name": "Path 7487",
    className: "cls-1",
    d: "M11.575,26.325l-1.35,1.35a.725.725,0,0,0,0,1.05.725.725,0,0,0,1.05,0l1.35-1.35a.742.742,0,0,0-1.05-1.05Z",
    transform: "translate(-1 -5.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7488",
    "data-name": "Path 7488",
    className: "cls-1",
    d: "M12.625,9.875l-1.35-1.35a.742.742,0,0,0-1.05,1.05l1.35,1.35a.725.725,0,0,0,1.05,0A.724.724,0,0,0,12.625,9.875Z",
    transform: "translate(-1 -1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMouseSpark);
export default __webpack_public_path__ + "static/media/Icon_Mouse_Spark.62d7747e51fd5647489c74e2d3a40bba.svg";
export { ForwardRef as ReactComponent };